export const confidentialityAgreement = (name?: string, date?: string) => {
  return [
    { text: 'Confidentiality Agreement', style: 'h1' },

    { text: [
        { text: 'This agreement (“Agreement”) will confirm the understanding between Sierra Expediting Inc (“Sierra”) and' },
        { text: ' NAME ' },
        { text: "(“Contractor”) concerning certain confidential information that will be provided to Contractor in relation to the contracts between Sierra and Contractor (“Contracts”)."},
      ], style: 'p' },

    { text: "1. The term “Confidential Information” includes all documents, materials and other information, whether in oral, written or electronic form, concerning or relating to the Contracts that are furnished by or on behalf of Sierra and identified by Sierra either orally or in writing as confidential to Contractor at the time of disclosure, or which, under the circumstances surrounding disclosure ought to be treated as confidential, and includes, without limitation, concepts, functionality, business plans, business strategies, employee information, customer information, vendor information, vendor agreements and terms, business analyses, cost information, financial information, information related to the marketing or promotion of any of Sierra’s products, services, information related to Sierra’s business policies or practices, and studies, reports or other documents or materials prepared by Contractor and its agents and employees which contain or reflect all or any portion of the originally disclosed materials. Notwithstanding the foregoing, Confidential Information does not include information that: (i) was or becomes generally available to the public other than as a result of a disclosure by Contractor or its agents or representatives to one or more unauthorized parties; or (ii) becomes available to Contractor on a non-confidential basis from an independent source without breach of any confidentiality obligations.", style: 'p', margin: [20, 0, 0, 10] },
    { text: "2. Contractor agrees to preserve the confidentiality of all Confidential Information acquired from Sierra or his agent and not to use such information except in performing work for Sierra. Contractor agrees that a breach of this Agreement will cause irreparable harm to Sierra and, in that event, in addition to other remedies provided by applicable law, Sierra shall be entitled to immediate issuance of a temporary restraining order or preliminary injunction enforcing this Agreement. Contractor shall employ all measures necessary to ensure that Confidential Information is secure. Contractor shall only share the Confidential Information with employees or agents who are essential to the accomplishment of the work of Contractor for Sierra related to the Contracts and then only if such employees and agents have signed a Confidentiality Agreement at least as protective of the Confidential Information as this Agreement.", style: 'p', margin: [20, 0, 0, 10] },
    { text: "3. The undersigned individuals have authority to enter into this agreement on behalf of the undersigned parties and each party acknowledges and agrees that this agreement shall bind each of their employees and representatives.", style: 'p', margin: [20, 0, 0, 10] },
    { text: "4. This Agreement, and all rights and powers granted hereby, will bind and inure to the benefit of the parties hereto and their respective successors and assigns, but neither this" +
        " Agreement nor any of the rights, interests, or obligations hereunder shall be assigned by any of the parties hereto without the prior written consent of the other parties hereto. Notwithstanding the above, Sierra may assign this Agreement to an entity which is controlled by Sierra without any necessity of consent by Contractor.", style: 'p', margin: [20, 0, 0, 20] },

    { canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 170,
          y1: 0,
          x2: 320,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 340,
          y1: 0,
          x2: 490,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
    },

    { text: `${name}`, margin: [0,-22, 0, 0]},
    { text: "Driver's Name", style: 'label', margin: [0,5,0,0]},
    { text: "Driver's Signature", style: 'label', margin: [170,-12,0,0]},
    { text: `${date}`, margin: [340,-32, 0, 0]},
    { text: "Date", style: 'label', margin: [340,5,0,0] },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 150,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 340,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    }, 

    { text: "Safety Management", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [340, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [340, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};